import axios from 'axios';

const getAddresses = async (customerID) => {
	try {
		const {
			data: { Data },
		} = await axios({
			method: 'GET',
			url: `/api/candispatchv3/SearchAddresses?payload={"Id":0,"SearchKeyword":"","Page":1,"Take":1000,"CustomerId":"${customerID}"}`,
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
			},
			data: null,
		});
		return Data;
	} catch (error) {
		console.log('GETADDRESSES FETCHING ERROR :>> ', error);
	}
};

export default getAddresses;
